import * as React from 'react';

import { useMRAIDViewability } from 'common/hooks/mraid-state';
import { injectTags } from 'common/js/inject-tags';
import { isOMIDSDKActivated } from 'common/js/omid/omid';

interface Props {
  inhouse: boolean;
  trackers: string;
  omidTrackers: string;
  omidTrackingEnabled: boolean;
  allowAgnosticTracking: boolean;
  htmlContainerSelector: string;
  scriptContainerSelector: string;
  overloadDocumentWrite: boolean;
  enableSentryLog: boolean;
}

let rendered = false;
const injectionTimeout = 250;

export function DisplayTrackers({
  inhouse,
  trackers,
  omidTrackers,
  omidTrackingEnabled,
  allowAgnosticTracking,
  htmlContainerSelector,
  scriptContainerSelector,
  overloadDocumentWrite,
  enableSentryLog
}: Props) {
  const isViewable = useMRAIDViewability();

  React.useEffect(() => {
    if (window.isOgyPreview) {
      return;
    }

    if (!rendered && isViewable) {
      rendered = true;

      let trackersCode = trackers;
      // Inject OMID trackers when tracking agnosticity is activated and OMID is deactivated
      const useOmidTracking = omidTrackingEnabled && isOMIDSDKActivated();
      if (allowAgnosticTracking && !useOmidTracking) {
        trackersCode += omidTrackers;
      }

      const defaultContainer = '#displayTrackers';

      // this will override the document.write
      setTimeout(() => {
        injectTags(
          trackersCode,
          htmlContainerSelector || defaultContainer,
          scriptContainerSelector || defaultContainer,
          defaultContainer,
          {
            allowInjectIntoBody: false,
            enableSentryLog,
            overloadDocumentWrite
          }
        );
      }, injectionTimeout);
    }
  });

  const style = {
    display: 'none'
  };
  return <div id="displayTrackers" style={style} />;
}

export function reset() {
  rendered = false;
}
